import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatCheckboxModule, MatIconModule, MatMenuModule, MatSlideToggleModule, MatToolbarModule, MatTooltipModule } from '@angular/material';
import { RouterModule, Routes } from '@angular/router';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { FcLocationInputModule } from '@core/components/fc-input/search-one/fc-location-input/fc-location-input.module';
import { StarsModule } from '@core/components/stars/stars.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CompanyService } from 'app/main/settings/accounts/companies/services/company.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CompanyComparisonComponent } from './company-comparison.component';
import { FilterComponent } from './components/filter/filter.component';
import { DialogChooseCompaniesComponent } from './dialogs/dialog-choose-companies/dialog-choose-companies.component';
import { DataTableMapperService } from './services/data-table.mapper.service';

const routes: Routes = [
  {
    path: 'relatorios/comparar-empresas',
    component: CompanyComparisonComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'COMPANY_COMPARISON.TITLE' }
  }
];

@NgModule({
  declarations: [
    CompanyComparisonComponent,
    FilterComponent,
    DialogChooseCompaniesComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    FcDateInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationsInputModule,
    FcCompaniesInputModule,
    FcLocationGroupsInputModule,
    MatIconModule,
    MatToolbarModule,
    MatCheckboxModule,
    NgxSkeletonLoaderModule,
    ReactiveFormsModule,
    MatTooltipModule,
    StarsModule,
    PipesModule,
    MatIconModule,
    MatSlideToggleModule,
    MatMenuModule,
    MatButtonModule,
    FormsModule,
    FuseSharedModule
  ],
  providers: [
    DataTableMapperService,
    CompanyService
  ],
  exports: [
    CompanyComparisonComponent
  ],
  entryComponents: [
    DialogChooseCompaniesComponent
  ]
})
export class CompanyComparisonModule { }
